import React from 'react';
import { LeafIcon, LayersIcon, ClockIcon, AlertTriangleIcon, ArchiveIcon, FrameIcon, GemIcon, SparklesIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
const icons = [LeafIcon, LayersIcon, ClockIcon, AlertTriangleIcon, ArchiveIcon, FrameIcon, GemIcon, SparklesIcon];
export function Modules() {
  return <section className="w-full bg-shell px-5 py-16 sm:px-8 lg:py-24" data-id="element-95" data-mp="145w81oqbhez6">
      <div className="mx-auto max-w-5xl" data-id="element-96" data-mp="147phfbsbedav">
        <SectionHeading overline="El contenido" size="lg" title={<>
              Todo lo que incluye la{' '}
              <span className="italic text-terracotta-500" data-id="element-98" data-mp="1d6b2bdl9e4et">guía completa</span>
            </>} data-id="element-97" data-mp="186y6i3cetn03" />

        <ol className="mt-14 grid gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3" data-id="element-99" data-mp="1i5xi9ush1yrb">
          {modules.map((module, index) => {
          const Icon = icons[index % icons.length];
          const isFirst = index === 0;
          return <li key={module.title} className={`relative flex h-full flex-col rounded-3xl bg-cream p-7 shadow-[0_18px_40px_-30px_rgba(56,52,44,0.55)] transition-[transform,box-shadow] duration-200 ease-soft hover:-translate-y-1 hover:shadow-[0_24px_48px_-30px_rgba(56,52,44,0.6)] sm:p-8 ${isFirst ? 'border-2 border-gold-400/60 sm:col-span-2 sm:flex-row sm:items-center sm:gap-8' : 'border border-gold-200/70'}`} data-id="element-100" data-mp="2tjj8zkdzc8ey" data-mpi={index}>
                <div className={isFirst ? 'flex-none' : ''} data-id="element-101" data-mp="3k0fz1bn4ldis">
                  <div className="flex items-center gap-3" data-id="element-102" data-mp="3f1uzlefp6xve">
                    <span className={`inline-flex items-center rounded-full px-3.5 py-1.5 text-[10.5px] font-bold uppercase tracking-[0.16em] ${isFirst ? 'bg-sage-700 text-cream' : 'bg-gold-100 text-gold-600'}`} data-id="element-103" data-mp="3aawe80fur9la">
                      {module.title}
                    </span>
                    <span className="h-px flex-1 border-t border-dashed border-gold-400/40 sm:w-10 sm:flex-none" aria-hidden="true" data-id="element-104" data-mp="31c14wfhihjdr" />
                    <span className={`flex flex-none items-center justify-center rounded-full ${isFirst ? 'h-11 w-11 bg-sage-100' : 'h-9 w-9 bg-sage-50'}`} data-id="element-105" data-mp="2rcacqkgfbggu">
                      <Icon className={`text-sage-600 ${isFirst ? 'h-5 w-5' : 'h-4 w-4'}`} aria-hidden="true" data-id="element-106" data-mp="2hn3d7ji7o86b" />
                    </span>
                  </div>
                </div>

                <h3 className={`mt-5 font-serif leading-tight text-sage-800 ${isFirst ? 'text-[1.7rem] sm:mt-0 sm:text-[2rem]' : 'text-[1.4rem]'}`} data-id="element-107" data-mp="28p1g3f1llzob">
                  {module.body}
                </h3>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}